import { Component, OnInit } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { CommonService } from 'src/app/service/common.service';
import { masterDataLob } from 'src/app/models/masterDataLob';
import { LOBproductConfigEnum } from 'src/app/enums/lob.enum';
import { Router } from '@angular/router';
import { tr } from 'date-fns/locale';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MenuIdService } from 'src/app/service/menu-id.service';
import { ToastrService } from 'ngx-toastr';

const policyType = [
  { masterDataID: "001", mdTitle: "Single Policy" },
  { masterDataID: "002", mdTitle: "Group Policy" }
];

const beforOnloadData = [
  {
    "pZLOBID": "1",
    "pZLOB": "",
    "mstGroupID": ''
  },
  {
    "pZLOBID": "2",
    "pZLOB": "",
    "mstGroupID": ''
  },
  {
    "pZLOBID": "3",
    "pZLOB": "",
    "mstGroupID": ''
  },
  {
    "pZLOBID": "4",
    "pZLOB": "",
    "mstGroupID": ''
  }
]
@Component({
  selector: 'app-product-cards-landing',
  templateUrl: './product-cards-landing.component.html',
  styleUrls: ['./product-cards-landing.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule]
})

export class ProductCardsLandingComponent implements OnInit {
  policyType = policyType;
  displayedCards = beforOnloadData;
  currentPage = 0;
  itemsPerPage = 4;
  LOBEnum: any = LOBproductConfigEnum;
  activeTab: any = [];
  insuranceTypeCards: masterDataLob[] = [];
  beforeLoad: boolean = false;
  leftArrowDisabled: boolean = true;
  rightArrowDisabled: boolean = false;
  showOriginalData: boolean = true;
  landingImgPath: string;
  constructor(
    private loader: LoaderService,
    private restService: RestService,
    private commonService: CommonService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private menuIDService : MenuIdService,
    private toastr : ToastrService
  ) {
 
   }

  ngOnInit(): void {
    this.menuIDService.landingImagePath$.subscribe(path => {
      this.landingImgPath = path;
    });
    this.loader.show();
    this.getLOB();
    this.setupResponsiveItemsPerPage();
  }

  setupResponsiveItemsPerPage(): void {
    this.breakpointObserver.observe([
      '(min-width: 1200px)', // Extra-large devices
      '(min-width: 991px)',  // Large devices
      '(min-width: 768px)',  // Medium devices
      '(min-width: 576px)'   // Small devices
    ]).subscribe(result => {
      if (result.breakpoints['(min-width: 1200px)']) {
        this.itemsPerPage = 4; // Extra large
      } else if (result.breakpoints['(min-width: 991px)']) {
        this.itemsPerPage = 3; // Large
      } else if (result.breakpoints['(min-width: 768px)']) {
        this.itemsPerPage = 2; // Medium
      } else if (result.breakpoints['(min-width: 576px)']) {
        this.itemsPerPage = 1; // Small
      } else {
        this.itemsPerPage = 1; // Extra small and below
      }
    });
  }


  getLOB(): void {
    const url = 'api/admin/Quotation/GetAllLOB';
    this.loader.show();
    this.restService.postCoreBaseData({}, url).subscribe(
      {
        next: (data: any) => {
          if (data.rcode === 200) {
            this.loader.hide();
            this.insuranceTypeCards = data.rObj.getAllLOB;
            //this.updateDisplayedCards();
            this.showOriginalData = false;

          } else {
            this.loader.hide();
            this.commonService.handleRcodeError(data);
          }
        },
        error: (error) => {
          if (error.rcode != 200) {
            this.loader.hide();
            this.loader.hide();
            this.commonService.handleStatusError(error);
            console.error(error)
          }
        }
      });
  }

  updateDisplayedCards(): void {
    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;

    this.displayedCards = this.insuranceTypeCards.slice(startIndex, endIndex);
    this.beforeLoad = false;

    this.loader.hide();
    this.leftArrowDisabled = this.currentPage === 0;
    this.rightArrowDisabled = endIndex >= this.insuranceTypeCards.length;
  }

  next(): void {
    if ((this.currentPage + 1) * this.itemsPerPage < this.insuranceTypeCards.length) {
      this.currentPage++;
      this.updateDisplayedCards();
    }
  }

  previous(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updateDisplayedCards();
    }
  }

  // openTypeOfInsuranceCard(typeOfInsurance): void {
  //   // const route = typeOfInsurance.mstGroupID === LOBproductConfigEnum.groupPersonalAccident ?
  //   //   'quotes/gpquotes-form' : 'quotes/quotes-form';
  //   const route = 'quotes/quotes-form';
  //   this.router.navigate([route, typeOfInsurance.mstGroupID]);
  // }
  openTypeOfInsuranceCard(typeOfInsurance: any): void {
    if (typeOfInsurance.mstGroupID === this.LOBEnum.motor) {
      const route = 'quotes/quotes-form';
      this.router.navigate([route, typeOfInsurance.mstGroupID]);
    } 
    //else {
    //   this.dialog.open(ServiceInProgressDialogComponent, {
    //     data: {
    //       message: 'This service is in progress. Please check back later.'
    //     }
    //   });
    // }
    else {
      this.toastr.info('This service is in progress. Please check back later.', 'Info');
    }
  }
  setActiveTab(tab: any): void {
    if (this.activeTab?.masterDataID !== tab.masterDataID) {
      this.activeTab = tab;
      this.currentPage = 0;
      this.updateDisplayedCards();
    }
  }
}
